import React, { useState, useEffect } from "react";
import { Outlet, Link, useNavigate } from 'react-router-dom'
import Logo from "../../common/Logo";
import userService from "../../../services/userService";

// add responsive assets (generated by script)
import forget480Webp from "../../../assets/forget-password-480.webp";
import forget800Webp from "../../../assets/forget-password-800.webp";
import forget1200Webp from "../../../assets/forget-password-1200.webp";
import forget480Jpg from "../../../assets/forget-password-480.jpg";
import forget800Jpg from "../../../assets/forget-password-800.jpg";
import forget1200Jpg from "../../../assets/forget-password-1200.jpg";

const ForgetPassword = () => {
  const { validateUser } = userService();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const savedUsername = localStorage.getItem("username");
    if (savedUsername) {
      setUsername(savedUsername);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username) {
      setError("User Name or Email is required");
    } else {
      setError("");
      try {
        const response = await validateUser(username);
        localStorage.setItem("username", username);
        navigate("/SetPassword", {
          state: {
            user: response.data,
            flow: "forgetPassword"
          }
        });
      } catch (error) {
        setError(error.message);
      }
    }
  };

  return (
    <section className="bg-tg-bg py-8 lg:py-[50px] min-h-screen">
      <div className="container mx-auto">
        <div className="flex justify-center mb-10"> <Logo /></div>
        <div className="bg-white rounded-lg overflow-hidden shadow-md">
          <div className="flex flex-col lg:flex-row items-stretch">
            {/* responsive banner: stacks above form on small screens, left column on lg */}
            <div className="w-full lg:w-1/2">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${forget480Webp} 480w, ${forget800Webp} 800w, ${forget1200Webp} 1200w`}
                  sizes="(max-width: 640px) 480px, (max-width: 1024px) 800px, 1200px"
                />
                <source
                  type="image/jpeg"
                  srcSet={`${forget480Jpg} 480w, ${forget800Jpg} 800w, ${forget1200Jpg} 1200w`}
                  sizes="(max-width: 640px) 480px, (max-width: 1024px) 800px, 1200px"
                />
                <img
                  src={forget1200Jpg}
                  alt="Forgot password banner"
                  loading="lazy"
                  className="w-full h-40 sm:h-64 lg:h-full object-cover"
                />
              </picture>
            </div>

            {/* form column */}
            <div className="w-full lg:w-1/2">
              <div className="w-full px-6 py-12 sm:p-10 lg:p-14">
                <h2 className="text-2xl sm:text-3xl font-bold text-dark mb-6">
                  Forgot Password?
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <InputBox
                    labelTitle="User Name / Email Address"
                    type="text"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  {error && <div className="text-red-500 text-sm mb-2">{error}</div>}

                  <div className="mt-6">
                    <button
                      type="submit"
                      className={`w-full rounded-md px-4 py-3 text-white ${!username ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"}`}
                      disabled={!username}
                    >
                      Next
                    </button>

                    <Outlet />
                  </div>
                </form>

                <div className="flex flex-wrap justify-center mt-8">
                  <p className="text-sm text-body-color">
                    <span className="pr-0.5"> Already have an account? </span>
                    <Link to={"/SignIn"} className="text-primary"> Sign In </Link>
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgetPassword;

const InputBox = ({ type, name, labelTitle, value, onChange }) => {
  return (
    <div className="mt-8">
      <label className="mb-2.5 block text-base text-dark font-medium">
        {labelTitle}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className="w-full rounded-md border border-[#E9EDF4] bg-transparent px-5 py-3 text-body-color outline-none focus:border-primary focus-visible:shadow-none"
        required
      />
    </div>
  );
};
